var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0519 11.1155L11.9688 16.9739C11.5325 17.3941 11.2353 17.9364 11.1168 18.5287L10.8063 20.0811C10.701 20.6073 11.1743 21.0675 11.7012 20.9514L13.2749 20.6043C13.8473 20.4781 14.3698 20.1873 14.7773 19.7681L20.6641 13.7122C21.1817 13.1977 21.0243 12.2045 20.3114 11.4874C19.5902 10.7619 18.5756 10.5949 18.0519 11.1155Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03125 20.9688C1.03125 16.3159 5.67798 12.3278 10.3247 13.6572",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56641 5.59551C4.56641 3.07454 6.61604 1.03087 9.14436 1.03087C11.6727 1.03087 13.7223 3.07454 13.7223 5.59551C13.7223 8.11648 11.6727 10.1602 9.14436 10.1602C6.61604 10.1602 4.56641 8.11648 4.56641 5.59551Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileProgress);
export default __webpack_public_path__ + "static/media/profile-progress.30c60429df5d6a0b31e2ff7c03972294.svg";
export { ForwardRef as ReactComponent };